import { Component } from '@angular/core';
import { CoreSignalExperienceEntity } from 'mj_generatedentities';
import { RegisterClass } from '@memberjunction/global';
import { BaseFormComponent } from '@memberjunction/ng-base-forms';

@RegisterClass(BaseFormComponent, 'Experiences') // Tell MemberJunction about this class
@Component({
    standalone: false,
    selector: 'gen-coresignalexperience-form',
    templateUrl: './coresignalexperience.form.component.html'
})
export class CoreSignalExperienceFormComponent extends BaseFormComponent {
    public record!: CoreSignalExperienceEntity;

    override async ngOnInit() {
        await super.ngOnInit();
        this.initSections([
            { sectionKey: 'details', sectionName: 'Details', isExpanded: true }
        ]);
    }
}

